import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

import './CertifiedTutors.css';

const CertifiedTutors = ({ useContactLink = false }) => {
  const tutors = [
    {
      name: 'Qaria Sadaf Sarfaraz',
      role: 'Online Quran Teacher',
      description: 'Highest satisfaction rate in first class most student',
      image: 'tutor-yousra.jpeg',
      profileUrl: '/our-tutors/qaria-sadaf-sarfaraz/'
    },
    {
      name: 'Molana Hafiz Qari Osama Hussein',
      role: 'Islamic scholar',
      description: 'Specialization in Islamic studies of Seeratun Nabi (S.A.W)',
      image: 'tutor-osama.jpg',
      profileUrl: '/our-tutors/molana-hafiz-qari-osama-hussein/'
    },
    {
      name: 'Molana Hafiz Kaleem Ullah',
      role: 'Islamic scholar',
      description: 'Specialization in Islamic studies of Seeratun Nabi (S.A.W)',
      image: 'tutor-kaleem.jpg',
      profileUrl: '/our-tutors/molana-hafiz-kaleem-ullah/'
    },
    {
      name: 'Aalima Qaria Yousra',
      role: 'Islamic Scholar',
      description: 'Highest satisfaction rate in first class most student',
      image: 'tutor-sadaf.jpeg',
      profileUrl: '/our-tutors/aalima-qaria-yousra/'
    }
  ];

  return (
    <section className="certified-tutors" id="tutors">
      <div className="certified-tutors__container">
        {/* Headings */}
        <div className="certified-tutors__badge-wrapper">
          <span className="certified-tutors__badge">Expert Islamic Faculty</span>
        </div>
        <h2 className="certified-tutors__title">Meet Our Certified Tutors</h2>
        <p className="certified-tutors__subtitle">
          Every Tutor Is Personally Verified Certified, Experienced, And Background-Checked.
        </p>
        <div className="certified-tutors__title-underline"></div>

        {/* Content Layout */}
        <div className="certified-tutors__content">
          {/* Left Column: Features List */}
          <div className="certified-tutors__features">
            {/* Feature 1 */}
            <div className="certified-tutors__feature-item">
              <div className="certified-tutors__feature-icon-wrapper">
                <svg className="certified-tutors__feature-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zM5.47 12.5L12 16l6.53-3.56v3.06l-6.53 3.56-6.53-3.56v-3.06z" />
                </svg>
              </div>
              <div className="certified-tutors__feature-text">
                <h3 className="certified-tutors__feature-title">Hifzul Quran</h3>
                <p className="certified-tutors__feature-desc">
                  Expert tutors graduated from Islamic University.
                </p>
              </div>
            </div>

            {/* Feature 2 */}
            <div className="certified-tutors__feature-item">
              <div className="certified-tutors__feature-icon-wrapper">
                <svg className="certified-tutors__feature-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                </svg>
              </div>
              <div className="certified-tutors__feature-text">
                <h3 className="certified-tutors__feature-title">Ijazah Holders</h3>
                <p className="certified-tutors__feature-desc">
                  Authentic learning with connected Sanad.
                </p>
              </div>
            </div>

            {/* Feature 3 */}
            <div className="certified-tutors__feature-item">
              <div className="certified-tutors__feature-icon-wrapper">
                <svg className="certified-tutors__feature-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                </svg>
              </div>
              <div className="certified-tutors__feature-text">
                <h3 className="certified-tutors__feature-title">Fluent English</h3>
                <p className="certified-tutors__feature-desc">
                  Easy communication during Quran sessions.
                </p>
              </div>
            </div>

            {/* Feature 4 */}
            <div className="certified-tutors__feature-item">
              <div className="certified-tutors__feature-icon-wrapper">
                <svg className="certified-tutors__feature-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2c-4.97 0-9 4.03-9 9 0 2.12.74 4.07 1.97 5.61L4.35 19.4c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l2.79-2.79C10.09 18.66 11.02 19 12 19c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 15c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z" />
                </svg>
              </div>
              <div className="certified-tutors__feature-text">
                <h3 className="certified-tutors__feature-title">Kids Specialists</h3>
                <p className="certified-tutors__feature-desc">
                  Fun and patient teaching style for kids.
                </p>
              </div>
            </div>
          </div>

          {/* Right Column: Swiper Carousel Slider */}
          <div className="certified-tutors__slider-container">
            <Swiper
              modules={[Pagination]}
              spaceBetween={30}
              grabCursor={true}
              pagination={{
                clickable: true,
                bulletClass: 'certified-tutors__pagination-bullet',
                bulletActiveClass: 'certified-tutors__pagination-bullet--active'
              }}
              breakpoints={{
                0: {
                  slidesPerView: 1.2,
                  spaceBetween: 20
                },
                576: {
                  slidesPerView: 1.8,
                  spaceBetween: 20
                },
                991: {
                  slidesPerView: 2.5,
                  spaceBetween: 30
                }
              }}
              className="certified-tutors__swiper"
            >
              {tutors.map((tutor, index) => (
                <SwiperSlide key={index}>
                  <div className="certified-tutors__card">
                    <div className="certified-tutors__card-image-wrapper">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/${tutor.image}`}
                        alt={tutor.name}
                        className="certified-tutors__card-img"
                      />
                    </div>
                    <div className="certified-tutors__card-content">
                      <h3 className="certified-tutors__card-name">{tutor.name}</h3>
                      <span className="certified-tutors__card-role">{tutor.role}</span>
                      <p className="certified-tutors__card-desc">{tutor.description}</p>
                      <a href={useContactLink ? "#contact" : tutor.profileUrl} className="certified-tutors__card-btn">
                        View Profile
                      </a>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertifiedTutors;

